import React from 'react'
import './header.css';
import CTA from './CTA';
import HeaderSocial from './HeaderSocial';

const Header = () => {
  return (
    <header id="home">
      <div className="header__bg-vector" />
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1 className="header__title">Chathura Prabashwara</h1>
        <h5 className='text-light header__subtitle'>
          <span className="typing">Fullstack Developer</span>
        </h5>
        <CTA/>
        <HeaderSocial/>
        <a href="#contact" className='scroll__down'>Scroll Down </a>
      </div>
    </header>
  )
}

export default Header